// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__dYkTP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__eK98H"};